import FetchStatusRepository   from "../../../../domain/fundamentals/fetch/FetchStatusRepository";
import NotifyRepository        from "../../../../domain/fundamentals/message/notify/NotifyRepository";
import CurrentPage             from "../../../../domain/fundamentals/pagination/CurrentPage";
import MailTemplate            from "../../../../domain/mail/template/MailTemplate";
import MailTemplateRepository  from "../../../../domain/mail/template/MailTemplateRepository";
import FetchStatusDataSource   from "../../../../infrastructure/datasource/common/fetch/FetchStatusDataSource";
import MailTemplateDataSource  from "../../../../infrastructure/datasource/mail/template/MailTemplateDataSource";
import NotifyDataSource        from "../../../../infrastructure/datasource/notify/NotifyDataSource";
import SetValidateErrorMessage from "../../error/SetValidateErrorMessage";
import GetMailTemplates        from "./GetMailTemplates";

class UpdateMailTemplate {
  private readonly mailTemplateRepository: MailTemplateRepository = new MailTemplateDataSource(this.dispatch);
  private readonly fetchStatusRepository: FetchStatusRepository = new FetchStatusDataSource(this.dispatch);
  private readonly notifyRepository: NotifyRepository = new NotifyDataSource(this.dispatch);
  private readonly setValidateErrorMessage: SetValidateErrorMessage = new SetValidateErrorMessage(this.dispatch);
  private readonly getMailTemplates: GetMailTemplates = new GetMailTemplates(this.dispatch);

  constructor(private readonly dispatch) {
  }

  public async execute(mailTemplate: MailTemplate, callback: (value: boolean) => void) {
    this.fetchStatusRepository.start();
    try {
      await this.mailTemplateRepository.update(mailTemplate);
      await this.getMailTemplates.execute(new CurrentPage());
      callback(false);
      this.notifyRepository.saveSuccess();
    } catch (e) {
      this.setValidateErrorMessage.execute(e);
      this.notifyRepository.saveFailure();
    } finally {
      this.fetchStatusRepository.finish();
    }
  }
}

export default UpdateMailTemplate;
